import { ApiService } from '@sparklayer-io/spark-dash-core/types/api';
import type { ApiHandlerContract } from '@sparklayer-io/spark-dash-core/types/handlers/api';
import type {
  SyncErrorFilter,
  SyncLogIdentifier,
  SyncLogStatus,
  SyncLogStatusWithErrors,
} from '../types';

export interface SyncLogIntegrationApiContract {
  status(): Promise<SyncLogStatus>;
  errors(filter?: SyncErrorFilter): Promise<SyncLogStatusWithErrors>;
}

export class SyncLogIntegrationApi extends ApiService implements SyncLogIntegrationApiContract {
  private identifier: SyncLogIdentifier;

  constructor(api: ApiHandlerContract, identifier: SyncLogIdentifier) {
    super(api);
    this.identifier = identifier;
  }

  private get integration(): string {
    return this.identifier.integration === 'shopify_plus' ? 'shopify' : this.identifier.integration;
  }

  status(): Promise<SyncLogStatus> {
    return this.api.proxy({
      method: 'GET',
      path: '/v1/sync-log/{integration}/{data_type}',
      params: {
        integration: this.integration,
        data_type: this.identifier.dataType,
      },
    });
  }

  errors(filter?: SyncErrorFilter): Promise<SyncLogStatusWithErrors> {
    const query = new URLSearchParams();
    if (filter?.externalId) {
      query.set('external_id', filter.externalId);
    }
    if (filter?.parent) {
      query.set('parent_data_type', filter.parent.dataType);
      query.set('parent_external_id', filter.parent.externalId);
    }
    const queryString = query.size > 0 ? `?${query}` : '';

    return this.api.proxy({
      method: 'GET',
      path: `/v1/sync-log/{integration}/{data_type}/errors${queryString}`,
      params: {
        integration: this.integration,
        data_type: this.identifier.dataType,
      },
    });
  }
}
